// Official Barverse wordmark (™) + TacoSun-marked Tacoverse endorsement line,
// linked back to tacoverse.com.
export default function Logo({ size = "sm" }) {
  const h = size === "lg" ? "h-9 md:h-11" : "h-6 md:h-7";
  return (
    <span className="flex items-center gap-3">
      <span className="flex items-start">
        <img src="/barverse-logo.png" alt="Barverse™" className={`${h} w-auto`} data-testid="barverse-logo" />
        <span className="ml-0.5 font-mono text-[9px] font-bold text-bv-sub" aria-hidden="true">™</span>
      </span>
      <a
        href="https://tacoverse.com"
        className="hidden items-center gap-2 border-l border-bv-line pl-3 sm:flex sm:leading-none"
        data-testid="logo-tacoverse-link"
        aria-label="Food by Tacoverse — visit tacoverse.com"
      >
        <img src="/images/tacosun.png" alt="" className="h-4 w-auto" aria-hidden="true" />
        <span className="whitespace-nowrap font-mono text-[8px] font-bold uppercase tracking-[0.32em] text-bv-sub transition-colors hover:text-bv-flame">
          Food by Tacoverse™
        </span>
      </a>
    </span>
  );
}
